import { render, staticRenderFns } from "./OrderSyncRow.vue?vue&type=template&id=70543f43&scoped=true&"
import script from "./OrderSyncRow.vue?vue&type=script&lang=js&"
export * from "./OrderSyncRow.vue?vue&type=script&lang=js&"
import style0 from "./OrderSyncRow.vue?vue&type=style&index=0&id=70543f43&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70543f43",
  null
  
)

export default component.exports